var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewOff = function SvgViewOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28003 21L22.03 3",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.05C10.471 19.3531 11.4828 19.5049 12.5 19.5C16.6 19.57 20.76 16.69 23.32 13.86C23.5962 13.5563 23.7492 13.1605 23.7492 12.75C23.7492 12.3395 23.5962 11.9437 23.32 11.64C22.3943 10.6169 21.3655 9.69197 20.25 8.88",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5899 7.27C16.0162 6.45359 14.2727 6.01855 12.4999 6C8.49991 5.93 4.29991 8.75 1.67991 11.64C1.40375 11.9437 1.25073 12.3395 1.25073 12.75C1.25073 13.1605 1.40375 13.5563 1.67991 13.86C3.09979 15.4473 4.76409 16.7977 6.60991 17.86",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.07C8.95752 14.3174 8.70504 13.3942 8.789 12.4703C8.87295 11.5464 9.2877 10.6839 9.95695 10.0414C10.6262 9.39893 11.5049 9.01971 12.4315 8.97352C13.3581 8.92733 14.2702 9.21727 15 9.79",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 12.75C16.25 13.2425 16.153 13.7301 15.9645 14.1851C15.7761 14.64 15.4999 15.0534 15.1517 15.4017C14.8034 15.7499 14.39 16.0261 13.9351 16.2145C13.4801 16.403 12.9925 16.5 12.5 16.5",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgViewOff;